import {keys} from 'ts-transformer-keys';

import {
    Images,
    Messages
} from '~/shared/src/utilities/dataExtraction';
import {Action} from '~/shared/src/utilities/action';
import {Function} from '~/shared/src/utilities/function';
import {Style} from '~/shared/src/utilities/style';
import {Query} from '~/shared/src/utilities/query';


type RequiredKeys<T> = { [K in keyof T]-? : {} extends Pick<T, K> ? never : K }[keyof T];
type RequiredOf<T> = Pick<T, RequiredKeys<T>>;


// CFG:Overview
export type OverviewInitialGroupState = 'collapsed' | 'expanded';
export type OverviewLinkTarget = 'panel' | 'popup';
export type OverviewRowsPerPage = 20 | 50 | 100 | 200 | 500;
export type Overview = {
    data : {
        id : number;
        key : string;
        name : string;

        columnLayout? : 'autoLayout' | 'forceFit';
        detailViewIdOrKeyQueryFieldName? : string;
        detailViewItemTypeNameOrQueryFieldName? : string;
        initialGroupState : OverviewInitialGroupState;
        isDeletable? : boolean;
        isEditable? : boolean;
        isEditMode? : boolean;
        isFilterable? : boolean;
        isSortable? : boolean;
        linkTarget : OverviewLinkTarget;
        reordering? : boolean;
        resizing? : boolean;
        rowsPerPage : OverviewRowsPerPage;
        usePaging : boolean;
    };
    groupingColumn? : string;
    query : Query;
    images : Images;
    actions? : Action[];
    functions? : Function[];
    messages : Messages;
    panelConfigIds? : number[];
    permissions : GroupPermissions;
    style : Style[];
};
export const overviewDataProps = keys<Overview['data']>();
export const overviewProps = keys<Overview>();
export const requiredOverviewProps = keys<RequiredOf<Overview>>();
